import { render, staticRenderFns } from "./SiteAside.vue?vue&type=template&id=59f88304&scoped=true"
import script from "./SiteAside.vue?vue&type=script&lang=js"
export * from "./SiteAside.vue?vue&type=script&lang=js"
import style0 from "./SiteAside.vue?vue&type=style&index=0&id=59f88304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f88304",
  null
  
)

export default component.exports